export default {"src":"/_next/static/media/editor-placeholder.b7fb7212.svg","height":615,"width":900,"blurWidth":0,"blurHeight":0};